import { useState } from "react";
import "./styles/support.css";

const SupportPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill in all required fields.");
      return;
    }

    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=admin@aftr.world&su=Support%20Request%20from%20${encodeURIComponent(
      formData.name
    )}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    )}`;

    window.open(gmailLink, "_blank");

    // Reset form fields
    setFormData({
      name: "",
      email: "",
      message: "",
    });

    // Status message
    setStatus(
      "We've opened Gmail in a new tab. Please finish sending your message there."
    );
  };

  return (
    <div className="support-container">
      {/* Header */}
      <header className="support-header">
        <div className="header-content">
          <h2 className="header-title">AFTR Support</h2>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <div className="hero-section">
          <h1 className="hero-title">How can we help?</h1>
          <p className="hero-description">
            Have a question or need assistance? We're here to help. Send us a
            message and we'll get back to you as soon as possible.
          </p>
        </div>

        {/* Contact Info */}
        <div className="contact-card">
          <p className="contact-text">You can also reach us directly at</p>
          <a
            href={`https://mail.google.com/mail/?view=cm&fs=1&to=support@aftr.world`}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-email"
          >
            admin@aftr.world
          </a>
        </div>

        {/* Support Form */}
        <div className="form-card">
          <div>
            {/* Name Field */}
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Your Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Enter your full name"
              />
            </div>

            {/* Email Field */}
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Your Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Enter your email address"
              />
            </div>

            {/* Message Field */}
            <div className="form-group">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows={6}
                value={formData.message}
                onChange={handleChange}
                required
                className="form-textarea"
                placeholder="Describe your question or issue in detail..."
              />
            </div>

            {/* Submit Button */}
            <button
              type="button"
              onClick={handleSubmit}
              className="submit-button"
            >
              Send Message
            </button>
          </div>

          {/* Status Message */}
          {status && (
            <div className="status-message">
              <p className="status-text">{status}</p>
            </div>
          )}
        </div>

        {/* FAQ Section */}
        <div className="faq-card">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          <div>
            <div className="faq-item">
              <h3 className="faq-question">
                How quickly will I receive a response?
              </h3>
              <p className="faq-answer">
                We typically respond to support requests within 24-48 hours
                during business days.
              </p>
            </div>

            <div className="faq-item">
              <h3 className="faq-question">
                What information should I include in my message?
              </h3>
              <p className="faq-answer">
                Please provide as much detail as possible about your issue,
                including any error messages, steps you've taken, and your
                device information if relevant.
              </p>
            </div>

            <div className="faq-item">
              <h3 className="faq-question">
                Can I attach files to my support request?
              </h3>
              <p className="faq-answer">
                Currently, our form doesn't support file attachments. Please
                email us directly at support@aftr.world if you need to send
                screenshots or other files.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SupportPage;
